import { core } from 'types';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

const { TockGiftCardResendRedeemRequest } = protos;

export function resendRedeemEmail(values: core.TockGiftCardResendRedeemRequest): ApiAction {
  return {
    TockApi: {
      postProto: '/gift/card/tock/resendRedeemEmail',
      request: TockGiftCardResendRedeemRequest.fromObject(values),
      type: ClowncarAppConstants.GIFT_RESEND_REDEEM_EMAIL,
      toast: 'Email resent!',
    },
  };
}
